import { z } from "../wire/zod";

export const createConfidenceVoteSessionResponseSchema = z.object({
  session: z.object({
    id: z.string(),
    piSessionId: z.string(),
    createdByUserId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    status: z.enum(["draft", "active", "ended"]),
    endedAt: z.string().datetime({ offset: true }).optional(),
    createdAt: z.string().datetime({ offset: true }),
    participatingTeamIds: z.array(z.string()),
    isAnonymousVote: z.boolean(),
    totalParticipants: z.number().int().optional(),
    totalVotes: z.number().int().optional(),
    voteBreakdown: z
      .object({
        veryHigh: z.number().int(),
        high: z.number().int(),
        medium: z.number().int(),
        low: z.number().int(),
        veryLow: z.number().int(),
        noConfidence: z.number().int(),
      })
      .optional(),
    averageScore: z.number().optional(),
  }),
});
export const endConfidenceVoteSessionResponseSchema = z.object({
  session: z.object({
    id: z.string(),
    piSessionId: z.string(),
    createdByUserId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    status: z.enum(["draft", "active", "ended"]),
    endedAt: z.string().datetime({ offset: true }).optional(),
    createdAt: z.string().datetime({ offset: true }),
    participatingTeamIds: z.array(z.string()),
    isAnonymousVote: z.boolean(),
    totalParticipants: z.number().int().optional(),
    totalVotes: z.number().int().optional(),
    voteBreakdown: z
      .object({
        veryHigh: z.number().int(),
        high: z.number().int(),
        medium: z.number().int(),
        low: z.number().int(),
        veryLow: z.number().int(),
        noConfidence: z.number().int(),
      })
      .optional(),
    averageScore: z.number().optional(),
  }),
});
export const getConfidenceVoteSessionsResponseSchema = z.object({
  sessions: z.array(
    z.object({
      id: z.string(),
      piSessionId: z.string(),
      createdByUserId: z.string(),
      title: z.string(),
      description: z.string().optional(),
      status: z.enum(["draft", "active", "ended"]),
      endedAt: z.string().datetime({ offset: true }).optional(),
      createdAt: z.string().datetime({ offset: true }),
      participatingTeamIds: z.array(z.string()),
      isAnonymousVote: z.boolean(),
      totalParticipants: z.number().int().optional(),
      totalVotes: z.number().int().optional(),
      voteBreakdown: z
        .object({
          veryHigh: z.number().int(),
          high: z.number().int(),
          medium: z.number().int(),
          low: z.number().int(),
          veryLow: z.number().int(),
          noConfidence: z.number().int(),
        })
        .optional(),
      averageScore: z.number().optional(),
    }),
  ),
});
export const getMyVoteResponseSchema = z.object({
  vote: z
    .object({
      confidenceLevel: z.enum(["no_confidence", "very_low", "low", "medium", "high", "very_high"]),
      createdAt: z.string().datetime({ offset: true }),
    })
    .optional(),
});
export const getParticipantsResponseSchema = z.object({
  participants: z.array(
    z.object({
      userId: z.string(),
      name: z.string(),
      email: z.string().optional(),
      imageUrl: z.union([z.string(), z.null()]).optional(),
      color: z.union([z.string(), z.null()]).optional(),
      hasVoted: z.boolean(),
      vote: z
        .union([
          z.object({
            confidenceLevel: z.enum([
              "no_confidence",
              "very_low",
              "low",
              "medium",
              "high",
              "very_high",
            ]),
            createdAt: z.string().datetime({ offset: true }),
          }),
          z.null(),
        ])
        .optional(),
    }),
  ),
  totalCount: z.number().int(),
  totalVotes: z.number().int(),
  isAnonymous: z.boolean(),
});
export const joinConfidenceVoteSessionResponseSchema = z.object({
  session: z.object({
    id: z.string(),
    piSessionId: z.string(),
    createdByUserId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    status: z.enum(["draft", "active", "ended"]),
    endedAt: z.string().datetime({ offset: true }).optional(),
    createdAt: z.string().datetime({ offset: true }),
    participatingTeamIds: z.array(z.string()),
    isAnonymousVote: z.boolean(),
    totalParticipants: z.number().int().optional(),
    totalVotes: z.number().int().optional(),
    voteBreakdown: z
      .object({
        veryHigh: z.number().int(),
        high: z.number().int(),
        medium: z.number().int(),
        low: z.number().int(),
        veryLow: z.number().int(),
        noConfidence: z.number().int(),
      })
      .optional(),
    averageScore: z.number().optional(),
  }),
});
export const noDataSchema = z.record(z.string(), z.never());
export const participantJoinedEventSchema = z.object({
  votingSessionId: z.string(),
  participant: z.object({
    userId: z.string(),
    name: z.string(),
    email: z.string().optional(),
    imageUrl: z.union([z.string(), z.null()]).optional(),
    color: z.union([z.string(), z.null()]).optional(),
    hasVoted: z.boolean(),
    vote: z
      .union([
        z.object({
          confidenceLevel: z.enum([
            "no_confidence",
            "very_low",
            "low",
            "medium",
            "high",
            "very_high",
          ]),
          createdAt: z.string().datetime({ offset: true }),
        }),
        z.null(),
      ])
      .optional(),
  }),
  totalParticipants: z.number().int(),
});
export const sessionCreatedEventSchema = z.object({
  id: z.string(),
  piSessionId: z.string(),
  createdByUserId: z.string(),
  title: z.string(),
  description: z.string().optional(),
  status: z.enum(["draft", "active", "ended"]),
  endedAt: z.string().datetime({ offset: true }).optional(),
  createdAt: z.string().datetime({ offset: true }),
  participatingTeamIds: z.array(z.string()),
  isAnonymousVote: z.boolean(),
  totalParticipants: z.number().int().optional(),
  totalVotes: z.number().int().optional(),
  voteBreakdown: z
    .object({
      veryHigh: z.number().int(),
      high: z.number().int(),
      medium: z.number().int(),
      low: z.number().int(),
      veryLow: z.number().int(),
      noConfidence: z.number().int(),
    })
    .optional(),
  averageScore: z.number().optional(),
});
export const sessionDeletedEventSchema = z.object({ votingSessionId: z.string() });
export const sessionEndedEventSchema = z.object({
  session: z.object({
    id: z.string(),
    piSessionId: z.string(),
    createdByUserId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    status: z.enum(["draft", "active", "ended"]),
    endedAt: z.string().datetime({ offset: true }).optional(),
    createdAt: z.string().datetime({ offset: true }),
    participatingTeamIds: z.array(z.string()),
    isAnonymousVote: z.boolean(),
    totalParticipants: z.number().int().optional(),
    totalVotes: z.number().int().optional(),
    voteBreakdown: z
      .object({
        veryHigh: z.number().int(),
        high: z.number().int(),
        medium: z.number().int(),
        low: z.number().int(),
        veryLow: z.number().int(),
        noConfidence: z.number().int(),
      })
      .optional(),
    averageScore: z.number().optional(),
  }),
  participants: z.array(
    z.object({
      userId: z.string(),
      name: z.string(),
      email: z.string().optional(),
      imageUrl: z.union([z.string(), z.null()]).optional(),
      color: z.union([z.string(), z.null()]).optional(),
      hasVoted: z.boolean(),
      vote: z
        .union([
          z.object({
            confidenceLevel: z.enum([
              "no_confidence",
              "very_low",
              "low",
              "medium",
              "high",
              "very_high",
            ]),
            createdAt: z.string().datetime({ offset: true }),
          }),
          z.null(),
        ])
        .optional(),
    }),
  ),
});
export const startConfidenceVoteSessionResponseSchema = z.object({
  session: z.object({
    id: z.string(),
    piSessionId: z.string(),
    createdByUserId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    status: z.enum(["draft", "active", "ended"]),
    endedAt: z.string().datetime({ offset: true }).optional(),
    createdAt: z.string().datetime({ offset: true }),
    participatingTeamIds: z.array(z.string()),
    isAnonymousVote: z.boolean(),
    totalParticipants: z.number().int().optional(),
    totalVotes: z.number().int().optional(),
    voteBreakdown: z
      .object({
        veryHigh: z.number().int(),
        high: z.number().int(),
        medium: z.number().int(),
        low: z.number().int(),
        veryLow: z.number().int(),
        noConfidence: z.number().int(),
      })
      .optional(),
    averageScore: z.number().optional(),
  }),
});
export const updateConfidenceVoteSessionResponseSchema = z.object({
  session: z.object({
    id: z.string(),
    piSessionId: z.string(),
    createdByUserId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    status: z.enum(["draft", "active", "ended"]),
    endedAt: z.string().datetime({ offset: true }).optional(),
    createdAt: z.string().datetime({ offset: true }),
    participatingTeamIds: z.array(z.string()),
    isAnonymousVote: z.boolean(),
    totalParticipants: z.number().int().optional(),
    totalVotes: z.number().int().optional(),
    voteBreakdown: z
      .object({
        veryHigh: z.number().int(),
        high: z.number().int(),
        medium: z.number().int(),
        low: z.number().int(),
        veryLow: z.number().int(),
        noConfidence: z.number().int(),
      })
      .optional(),
    averageScore: z.number().optional(),
  }),
});
export const voteCastEventSchema = z.object({
  votingSessionId: z.string(),
  userId: z.string().optional(),
  totalVotes: z.number().int(),
});
